import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import Category from "../components/pages/Category/Category";
const BASE_URL = process.env.REACT_APP_API_URL;

// 🔹 Fetch All Products
// export const fetchProducts = createAsyncThunk("products/fetchAll", async () => {
//   const response = await axios.get(`${BASE_URL}/api/products`);
//   return response.data;
// });



export const fetchProducts = createAsyncThunk("products/fetchProducts", async (params, { rejectWithValue }) => {
  if (process.env.NODE_ENV === "development") {
    console.log("params slice", params);
  }
  try {
    const response = await axios.get(`${BASE_URL}/api/products`, { params });
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response?.data);
  }
});

export const searchProducts = createAsyncThunk("products/searchProducts", async (params, { rejectWithValue }) => {
  if (process.env.NODE_ENV === "development") {
    console.log("params slice search===>>>>>>>>>>>>>>>>>>>>>>", params);
  }
  try {
    // const response = await axios.get(`${BASE_URL}/api/products?keyword=${params}`);
    const response = await axios.get(`${BASE_URL}/api/products`, { params });
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response?.data);
  }
});

// 🔹 Get Product
export const getProduct = createAsyncThunk("products/getProductById", async (id) => {
  const response = await axios.get(`${BASE_URL}/api/products/${id}`);
  if (process.env.NODE_ENV === "development") {
    console.log("response data ++++", response.data);
  }
  return response.data;
});

// 🔹 Get Product By Name
export const getProductByName = createAsyncThunk("products/getProductByName", async (slug) => {
  const response = await axios.get(`${BASE_URL}/api/products/slug/${slug}`);
  if (process.env.NODE_ENV === "development") {
    console.log("details response data ++++", response.data);
  }
  return response.data;
});

// 🔹 Get Product by Description
// export const getProduct = createAsyncThunk("products/getProductByDescription", async (description) => {
//   const response = await axios.get(`${BASE_URL}/api/products?description=${encodeURIComponent(description)}`);
//   console.log("response data ++++", response.data);
//   return response.data;
// });

// 🔹 Add a New Product
export const addProduct = createAsyncThunk("products/add", async (productData, { rejectWithValue }) => {
  try {
    const token = localStorage.getItem("token");
    const response = await axios.post(`${BASE_URL}/api/products`, productData, {
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" },
    });
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

// 🔹 Update a Product
export const updateProduct = createAsyncThunk("products/update", async ({ id, productData }, { rejectWithValue }) => {
  try {
    const token = localStorage.getItem("token");
    const response = await axios.put(`${BASE_URL}/api/products/${id}`, productData, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

// 🔹 Delete a Product
export const deleteProduct = createAsyncThunk("products/delete", async (id, { rejectWithValue }) => {
  try {
    const token = localStorage.getItem("token");
    await axios.delete(`${BASE_URL}/api/products/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return id;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

// Async thunk for uploading Excel
export const uploadExcel = createAsyncThunk("products/uploadExcel", async (formData, { rejectWithValue }) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/products/upload-excel`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (err) {
    return rejectWithValue(err.response.data);
  }
}
);

export const submitRating = createAsyncThunk('products/submitRating', async ({ productId, orderId, rating }, { rejectWithValue }) => {
  try {
    const token = localStorage.getItem("token");
    const response = await axios.post(`${BASE_URL}/api/products/${productId}/rate`, {
      orderId,
      rating,
    }, {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (process.env.NODE_ENV === "development") {
      console.log("addOrUpdate rating - resonse", response.data);
    }
    return response.data;
  } catch (error) {
    if (process.env.NODE_ENV === "development") {
      console.log("addOrUpdate rating - res error", error.response.data);
    }

    return rejectWithValue(error.response.data);
  }
}
);

export const getProductByCategory = createAsyncThunk("products/getProductByCategory", async (category, params, { rejectWithValue }) => {
  if (process.env.NODE_ENV === "development") {
    console.log("getProductByCategory params slice", params);
  }
  try {
    const response = await axios.get(`${BASE_URL}/api/category/${category}`, { params });
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response?.data);
  }
});

// 🔹 Product Slice
const productSlice = createSlice({
  name: "products",
  initialState: {
    products: [],
    product: null,
    loading: false,
    error: null,
    success: "",
    message: "",
    page: 1,
    pages: 1,
  },
  reducers: {
    clearMessages: (state) => {
      state.success = "";
      state.error = "";
      state.message = "";
    },
    clearProduct: (state) => {
      state.product = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchProducts.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProducts.fulfilled, (state, action) => {
        state.loading = false;
        state.products = action.payload.products;
        state.total = action.payload.total;
        state.page = action.payload.page;
        state.pages = action.payload.pages;
      })
      .addCase(fetchProducts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(searchProducts.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(searchProducts.fulfilled, (state, action) => {
        state.loading = false;
        state.products = action.payload.products;
        state.total = action.payload.total;
        state.page = action.payload.page;
        state.pages = action.payload.pages;
      })
      .addCase(searchProducts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // .addCase(fetchProducts.pending, (state) => {
      //   state.loading = true;
      // })
      // .addCase(fetchProducts.fulfilled, (state, action) => {
      //   state.loading = false;
      //   state.products = action.payload;
      // })
      // .addCase(fetchProducts.rejected, (state, action) => {
      //   state.loading = false;
      //   state.error = action.payload;
      // })
      .addCase(getProduct.pending, (state) => {
        state.loading = true;
      })
      .addCase(getProduct.fulfilled, (state, action) => {
        state.loading = false;
        state.products = action.payload;
      })
      .addCase(getProduct.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(addProduct.fulfilled, (state, action) => {
        state.products.push(action.payload);
      })
      .addCase(updateProduct.fulfilled, (state, action) => {
        state.products = state.products.map((product) =>
          product._id === action.payload._id ? action.payload : product
        );
      })
      .addCase(deleteProduct.fulfilled, (state, action) => {
        state.products = state.products.filter((product) => product._id !== action.payload);
      })

      .addCase(uploadExcel.pending, (state) => {
        state.loading = true;
      })
      .addCase(uploadExcel.fulfilled, (state, action) => {
        state.loading = false;
        state.success = action.payload.message;
      })
      .addCase(uploadExcel.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload.error || "Upload failed";
      })

      .addCase(submitRating.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(submitRating.fulfilled, (state, action) => {
        state.loading = false;
        state.product = action.payload.product;
        state.message = action.payload.message;
      })
      .addCase(submitRating.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.error;
        state.message = action.payload?.message;
      })

      .addCase(getProductByName.pending, (state) => {
        state.loading = true;
      })
      .addCase(getProductByName.fulfilled, (state, action) => {
        state.loading = false;
        state.products = action.payload;
      })
      .addCase(getProductByName.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(getProductByCategory.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getProductByCategory.fulfilled, (state, action) => {
        state.loading = false;
        state.products = action.payload.products;
        state.total = action.payload.total;
        state.page = action.payload.page;
        state.pages = action.payload.pages;
      })
      .addCase(getProductByCategory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      ;

  },
});
export const { clearMessages } = productSlice.actions;
export default productSlice.reducer;
